import { ServiceType } from '../../../../../../helpers/services';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQrStore } from '../../../../../../store/use-qr-store';

export const useQrServices = () => {
  const { handleUpdateQr, qr } = useQrStore();
  const { t } = useLang();

  const handleChangeServices = (e: ServiceType) => {
    const isExist = qr?.services?.includes(e);
    if (isExist) {
      handleUpdateQr({ services: qr?.services?.filter((item) => item !== e) });
      return;
    }
    handleUpdateQr({ services: [...(qr?.services || []), e] });
  };

  return {
    qr,
    handleChangeServices,
    t,
  };
};
